// extracted by mini-css-extract-plugin
export default {"container":"seperator_container__6dE9U","line":"seperator_line__P8qi3","word":"seperator_word__JhtCz"};